import Vue from "vue";
import VueRouter from "vue-router";

import ViewHome from "@/views/Home";
import ViewDashboard from "@/views/Dashboard";
import ViewGrade from "@/views/Grade";
import ViewNotifications from "@/views/Notifications";
import ViewNotification from "@/views/Notification";
import ViewSchedules from "@/views/Schedules";
import ViewTheses from "@/views/Theses";
import ViewThesis from "@/views/Thesis";
import ViewProfile from "@/views/Profile";
import ViewBackLogin from "@/views/Backlogin";
import ViewAbout from "@/views/About";
import ViewChangelog from "@/views/Changelog";
import store from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
	mode: "history",
	routes: [
		{
			path: "/login/:token/",
			redirect: to => {
				const { params } = to;
				if (params.token && String(params.token).trim() != "") {
					localStorage.setItem("token", String(params.token).trim());
					return { name: "theses" };
				}
			}
		},
		{
			name: "backlogin",
			path: "/backlogin",
			component: ViewBackLogin,
			meta: {
				guest: true,
				title: "Backlogin"
			}
		},
		{
			name: "about",
			path: "/about",
			component: ViewAbout,
			meta: {
				requiresLogin: true,
				title: "About"
			}
		},
		{
			name: "changelog",
			path: "/changelog",
			component: ViewChangelog,
			meta: {
				requiresLogin: true,
				title: "Changelog"
			}
		},
		{
			name: "home",
			path: "/",
			component: ViewHome,
			meta: {
				guest: true,
				title: "Thesis e-System"
			}
		},
		{
			name: "dashboard",
			path: "/dashboard",
			component: ViewDashboard,
			meta: {
				requiresLogin: true,
				title: "Dashboard"
			}
		},
		{
            name: "grade",
            path: "/grade/:id",
            component: ViewGrade,
            props: (route) => {
                return {
                    id: parseInt(route.params.id)
                }
            },
            meta: {
                requiresLogin: true,
                title: 'Grades'
            }
        },
		{
			name: "notifications",
			path: "/notifications",
			component: ViewNotifications,
			meta: {
				requiresLogin: true,
				title: "Notifications"
			}
		},
		{
			name: "notification",
			path: "/notification/:id",
			component: ViewNotification,
			props: true,
			meta: {
				requiresLogin: true,
				title: "Notification"
			}
		},
		{
			name: "schedule",
			path: "/schedule",
			component: ViewSchedules,
			meta: {
				requiresLogin: true,
				title: "Schedules"
			}
		},
		{
			name: "theses",
			path: "/theses",
			component: ViewTheses,
			meta: {
				requiresLogin: true,
				title: "Theses"
			}
		},
		{
			name: "thesis_new",
			path: "/thesis",
			component: ViewThesis,
			props: () => {
				return {
					id: 0,
					layout: "create"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "thesis_view",
			path: "/thesis/:id",
			component: ViewThesis,
			props: route => {
				return {
					id: parseInt(route.params.id),
					layout: "view"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "thesis_update",
			path: "/thesis/:id/update",
			component: ViewThesis,
			props: route => {
				return {
					id: parseInt(route.params.id),
					layout: "update"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "thesis_add_courses",
			path: "/thesis/:id/add_courses",
			component: ViewThesis,
			props: route => {
				return {
					id: parseInt(route.params.id),
					layout: "add_courses"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "thesis_add_students",
			path: "/thesis/:id/add_students",
			component: ViewThesis,
			props: route => {
				return {
					id: parseInt(route.params.id),
					layout: "add_students"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "thesis_add_teachers",
			path: "/thesis/:id/add_teachers",
			component: ViewThesis,
			props: route => {
				return {
					id: parseInt(route.params.id),
					layout: "add_teachers"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "thesis_upload_file",
			path: "/thesis/:id/upload_file",
			component: ViewThesis,
			props: route => {
				return {
					id: parseInt(route.params.id),
					layout: "upload_file"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "thesis_upload_fileproposal",
			path: "/thesis/:id/upload_file_proposal",
			component: ViewThesis,
			props: route => {
				return {
					id: parseInt(route.params.id),
					layout: "upload_file_proposal"
				};
			},
			meta: {
				requiresLogin: true,
				title: "Thesis"
			}
		},
		{
			name: "profile",
			path: "/profile",
			component: ViewProfile,
			meta: {
				requiresLogin: true,
				title: "Profile"
			}
		},
		{ path: "*", redirect: { path: "/" } }
	]
});

router.beforeEach((to, from, next) => {
	try {
		document.title = to.meta.title || "";
		if (to.matched.some(record => record.meta.requiresLogin)) {
			if (localStorage.getItem("token") == (null || undefined)) {
				next({
					path: "/",
					params: { nextUrl: to.fullPath }
				});
			} else {
				store
					.dispatch("http_get_user_data", { token: localStorage.getItem("token") })
					.then(resp => {
						if (resp) {
							next();
							return;
						}
						throw "Logged out";
					})
					.catch(() => {
						localStorage.removeItem("token");
						next({ path: "/" });
					});
			}
		} else if (to.matched.some(record => record.meta.guest)) {
			if (localStorage.getItem("token") == (null || undefined)) {
				next();
			} else {
				next({ name: "dashboard" });
			}
		} else {
			next({ path: "/" });
		}
	} catch (error) {
		console.log(error);
	}
});

export default router;
